import { useEffect } from "react";

import { useWsContext } from "./context";

export function useWebSocket(eventType: string, handler: (payload: unknown) => void) {
  const { subscribe } = useWsContext();
  useEffect(() => {
    return subscribe(eventType, handler);
  }, [eventType, handler, subscribe]);
}
